import { PMP } from './PMP';

export class ContentChannel extends PMP {}
